import { api } from '../../../api-helper';
import { URLS } from '../../../../constants/URLS';

export const createNewOrder = (orderData) => {
  return api.post(URLS.order, orderData, {
    headers: {
      needsToken: true
    }
  });
};

export const updateOrder = (orderID, orderData) => {
  return api.put(`${URLS.order}?id=${orderID}`, orderData, {
    headers: {
      needsToken: true
    }
  });
};

export const getOrderFormFieldRules = (fieldValues = {}) => {
  return api.post(URLS.orderFormFieldRules, fieldValues, {
    headers: {
      needsToken: true
    }
  });
};

export const getOrderByID = (orderID) => {
  return api.get(`${URLS.order}?id=${orderID}`, {
    headers: {
      needsToken: true
    }
  });
};

export const enableOrderByOrderID = (orderID) => {
  return api.put(
    `${URLS.orderEnable}?id=${orderID}`,
    {},
    {
      headers: {
        needsToken: true
      }
    }
  );
};

export const cancelOrderByOrderID = (orderID) => {
  return api.delete(
    `${URLS.orderCancel}?id=${orderID}`,

    {
      headers: {
        needsToken: true
      }
    }
  );
};

export const getMilestonesTrack = (orderID) => {
  return api.get(`${URLS.milestone}?id=${orderID}`, {
    headers: {
      needsToken: true
    }
  });
};

export const createClient = (clinetData) => {
  return api.post(URLS.client, clinetData, {
    headers: {
      needsToken: true
    }
  });
};

export const updateClient = (clinetData) => {
  return api.put(URLS.client, clinetData, {
    headers: {
      needsToken: true
    }
  });
};

export const getBuyers = (searchQuery, clientId, projectID, page, limit) => {
  return api.get(URLS.buyers, {
    params: {
      ...(searchQuery && { query: searchQuery }),
      clientId: clientId,
      ...(projectID && { projectID: projectID }),
      ...(page && { page: page }),
      ...(limit && { limit: limit })
    },

    headers: {
      needsToken: true
    }
  });
};

export const createBuyer = (buyerData) => {
  return api.post(URLS.buyer, buyerData, {
    headers: {
      needsToken: true
    }
  });
};

export const updateBuyer = (buyerData) => {
  return api.put(URLS.buyer, buyerData, {
    headers: {
      needsToken: true
    }
  });
};

export const getSellers = (searchQuery, clientId, projectID) => {
  return api.get(URLS.sellers, {
    params: {
      ...(searchQuery && { query: searchQuery }),
      clientId: clientId,
      ...(projectID && { projectID: projectID })
    },
    headers: {
      needsToken: true
    }
  });
};

export const createSeller = (sellerData) => {
  return api.post(URLS.seller, sellerData, {
    headers: {
      needsToken: true
    }
  });
};

export const updateSeller = (sellerData) => {
  return api.put(URLS.seller, sellerData, {
    headers: {
      needsToken: true
    }
  });
};

export const getSearcher = (searchQuery) => {
  return api.get(
    `${URLS.partners}${searchQuery ? '?query=' + searchQuery : ''}`,
    {
      headers: {
        needsToken: true
      }
    }
  );
};

export const getOrderDetailsTabList = () => {
  return api.get(URLS.orderDetailsTabList, {
    headers: {
      needsToken: true
    }
  });
};

export const getOrderPreviewSortList = () => {
  return api.get(URLS.orderPreviewSortList, {
    headers: {
      needsToken: true
    }
  });
};

export const getOrderPreviewFilterList = () => {
  return api.get(URLS.orderPreviewFilterList, {
    headers: {
      needsToken: true
    }
  });
};

export const getOrderDashbaordList = (searchQuery, bodydata, page, limit) => {
  return api.post(
    `${URLS.orderDashboard}?${searchQuery ? `query=${searchQuery}` : ''}${
      page ? `&page=${page}` : ''
    }${limit ? `&limit=${limit}` : ''}`,
    bodydata,
    {
      headers: { needsToken: true }
    }
  );
};

export const getOrderList = (query, limit = 5) => {
  return api.get(URLS.orderList, {
    params: {
      query: query,
      limit: limit
    },
    headers: {
      needsToken: true
    }
  });
};

export const getOrderInterestTypes = () => {
  return api.get(URLS.orderInterestTypes, {
    headers: {
      needsToken: true
    }
  });
};

export const getOrderAbstractors = (data) => {
  return api.post(URLS.getOrderAbstractors, data, {
    headers: {
      needsToken: true
    }
  });
};

export const placeOrderFromEmail = (mailID) => {
  return api.post(
    `${URLS.placeOrderFromEmail}?id=${mailID}`,
    {},
    {
      headers: {
        needsToken: true
      }
    }
  );
};
